import { typedQueryClient } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";

import type { CarCheck, Pin, QuestionResult, QuestionResultID } from "models";

type UpdateQuestionResultPinHistoryProps = {
  checks: CarCheck[];
  question_result_id: QuestionResultID;
  updatePinHistory: (questionResult: QuestionResult) => Pin[];
};

export const updateQuestionResultPinHistory = ({ checks, question_result_id, updatePinHistory }: UpdateQuestionResultPinHistoryProps) => {
  const checkIdx = checks.findIndex(check => check.question_items?.some(qr => qr.id === question_result_id));
  if (checkIdx < 0 || !checks[checkIdx].question_items?.length) return;

  const questionResults = checks[checkIdx].question_items;
  const questionResultIdx = questionResults.findIndex(qr => qr.id === question_result_id);
  if (questionResultIdx < 0) return;

  const questionResult = questionResults[questionResultIdx];

  typedQueryClient.setQueryData(
    AppointmentDetailsKeys.checks,
    checks.with(checkIdx, {
      ...checks[checkIdx],
      question_items: questionResults.with(questionResultIdx, { ...questionResult, pin_history: updatePinHistory(questionResult) })
    })
  );
};
